'use strict';

angular.module('shiftTraderApp')
  .controller('ProjectionsCtrl', function ($scope, $uibModalInstance, params, initialProjections, Projections, $q, toastr) {
    $scope.me = params.me;
    $scope.org = params.org;
    $scope.dates = params.dates;

    $scope.subtitle = $scope.dates[0].format('MMM D') + ' to ' + $scope.dates[6].format('MMM D');

    $scope.close = function() {
      $uibModalInstance.close();
    };

    var weekProjections = _.where(initialProjections, {type: 'weekly'});

    if (weekProjections.length > 0) {
      $scope.weekProjection = _.first(weekProjections);
    } else {
      $scope.weekProjection = {
        week_labor_percentage_goal: ''
      };
    }

    $scope.dailyProjections = _.map($scope.dates, function(dt) {
      var temp;
      var dtFormatted = dt.format('YYYY-MM-DD');

      var projMatch = _.find(initialProjections, function(proj) {
        return proj.target_date === dtFormatted && proj.type === 'daily';
      });

      if (projMatch) {
        temp = projMatch.data.total;
      } else {
        temp = {
          cost: '',
          gross_revenue: '',
          labor_hours: ''
        };
      }

      return {
        date: dt,
        props: temp
      }
    });

    $scope.saveProjections = function() {
      var changedProjs = _.where($scope.dailyProjections, {_changed: true});

      var promises = _.map(changedProjs, function(proj, idx) {
        return Projections.create({
          organization_id: $scope.org.id,
          target_date: proj.date.format('YYYY-MM-DD'),
          data: {
            _v: 1,
            total: {
              cost: proj.props.cost,
              labor_hours: proj.props.labor_hours,
              gross_revenue: proj.props.gross_revenue
            }
          },
          type: 'daily'
        })
          .then(function(projection) {
            return projection;
          }, function() {
            return undefined;
          });
      });

      if ($scope.weekProjection._changed) {
        promises.push(Projections.create({
          organization_id: $scope.org.id,
          target_date: $scope.dates[0].format('YYYY-MM-DD'),
          week_labor_percentage_goal: $scope.weekProjection.week_labor_percentage_goal,
          type: 'weekly'
        })
          .then(function(projection) {
            return projection;
          }, function() {
            return undefined;
          }));
      }

      $q.all(promises)
        .then(function(results) {
          $uibModalInstance.close(results);
        }, function() {
          console.log('had an issue saving. Try again!');
          toastr.error('We had an issue saving your projections. Please try again.', 'Error');
        })
    };
  });
